export default __webpack_public_path__ + "static/media/ensure850.d057ca41.jpg";